export default __webpack_public_path__ + "static/media/1.blur.46b80abb.jpg";